import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type ZBatteryObject } from '../../services/batteryService'

export interface batteryState {
  isLoading: boolean
  loadingError: string | null
  httpStatus: number | null
  data: ZBatteryObject | null
}

// Initial state of the slice
const initialState: batteryState = {
  isLoading: true,
  loadingError: null,
  httpStatus: null,
  data: null
}

// Slice to return from action
const batteryDataSlice = createSlice({
  name: 'batteryData',
  initialState,
  reducers: {
    batteryDataLoadingAction: (state) => {
      state.isLoading = true
      state.loadingError = null
      state.httpStatus = null
      state.data = null
    },
    batteryDataUpdateAction: (state, action: PayloadAction<{ data: ZBatteryObject, httpStatus: number }>) => {
      state.isLoading = false
      state.loadingError = null
      state.httpStatus = action.payload.httpStatus
      state.data = action.payload.data
    },
    batteryDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      state.isLoading = false
      state.loadingError = action.payload.errorMessage
      state.httpStatus = action.payload.httpStatus
      state.data = null
    }
  }
})

export const {
  batteryDataLoadingAction,
  batteryDataUpdateAction,
  batteryDataErrorAction
} = batteryDataSlice.actions

export default batteryDataSlice.reducer
